import * as actionTypes from '../../constants/actionTypes';
import { SidebarTab } from '../../constants/paths/internal';

export interface ISetTab {
  type: actionTypes.SET_TAB;
  menuTab: SidebarTab;
}

export const setMenuTab = (menuTab: SidebarTab): ISetTab => ({
  type: actionTypes.SET_TAB,
  menuTab,
});

export type SetMenuTab = typeof setMenuTab;

export interface ISetSidebarCollapsed {
  type: actionTypes.SET_SIDEBAR_COLLAPSED;
  collapsed: boolean;
}

export const setSidebarCollapsed = (collapsed: boolean): ISetSidebarCollapsed => ({
  type: actionTypes.SET_SIDEBAR_COLLAPSED,
  collapsed,
});
